import { render, staticRenderFns } from "./ProductPreviewInList.vue?vue&type=template&id=1c94096f&scoped=true&"
import script from "./ProductPreviewInList.vue?vue&type=script&lang=js&"
export * from "./ProductPreviewInList.vue?vue&type=script&lang=js&"
import style0 from "./ProductPreviewInList.vue?vue&type=style&index=0&id=1c94096f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c94096f",
  null
  
)

export default component.exports